import { Ref } from '@one/web-components/dist/types/components';
import { CustomTableComponent, CustomTableConfig } from 'commons/components';
import { CustomTableSortItems } from 'commons/components/table/sort/custom-table-sorting.model';
import { useTranslation } from 'core/i18n/i18n';
import {
    OPERATOR_CUSTOM_NOTIFICATIONS_I18N_PREFIX,
    OPERATOR_CUSTOM_NOTIFICATIONS_UNAVAILABLE_KEY,
} from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.constants';
import { OperatorCustomNotificationRow } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.model';

interface SettingsOperatorCustomNotificationsListComponentProps {
    rows: OperatorCustomNotificationRow[];
    config: CustomTableConfig<OperatorCustomNotificationRow>;
    isLoading: boolean;
    hasFailedToLoad: boolean;
    defaultSort: CustomTableSortItems;
    onSortOrderChange: (sortItems: CustomTableSortItems) => void;
    optionComponents: React.ReactNode;
    selectedRows: OperatorCustomNotificationRow[];
    selectedRowIds: Set<string>;
    headerCheckboxProps: Partial<HTMLOwcCheckboxElement & Ref<HTMLOwcCheckboxElement>>;
    onSelectRow: (id: string, isSelected: boolean) => void;
    onClickRow: (id: string) => void;
    rowOptions?: (row: OperatorCustomNotificationRow) => React.ReactElement[];
}

export const SettingsOperatorCustomNotificationsListComponent: React.FC<
    SettingsOperatorCustomNotificationsListComponentProps
> = ({
    rows,
    config,
    isLoading,
    hasFailedToLoad,
    defaultSort,
    onSortOrderChange,
    optionComponents,
    selectedRows,
    selectedRowIds,
    headerCheckboxProps,
    onSelectRow,
    onClickRow,
    rowOptions,
}) => {
    const { t } = useTranslation();

    return (
        <CustomTableComponent<OperatorCustomNotificationRow>
            headerTitle={t(`${OPERATOR_CUSTOM_NOTIFICATIONS_I18N_PREFIX}.list.title`)}
            loading={isLoading}
            totalElements={rows.length}
            tableData={rows}
            config={config}
            horizontalScroll
            selectedRows={selectedRows}
            selectedRowIds={selectedRowIds}
            headerCheckboxProps={headerCheckboxProps}
            onSelectRow={(id, event) => onSelectRow(id, event.detail)}
            onClickRow={onClickRow}
            rowOptions={rowOptions}
            sortingProps={{ defaultSort, onSortOrderChange }}
            emptyMessage={t(
                hasFailedToLoad
                    ? OPERATOR_CUSTOM_NOTIFICATIONS_UNAVAILABLE_KEY
                    : `${OPERATOR_CUSTOM_NOTIFICATIONS_I18N_PREFIX}.list.empty`
            )}
            optionComponents={optionComponents}
        />
    );
};
